import { IconProps } from '../types';
import Theme from '../../../components-library/Theme';
import classnames from 'classnames';

export default function RoomServiceIcon({ color, className }: IconProps) {
  return (
    <svg
      viewBox="0 -960 960 960"
      className={classnames('w-5', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M173-600h614l-34-120H208l-35 120Zm307-60Zm192 140H289l-11 80h404l-10-80ZM160-160l49-360h-89q-20 0-31.5-16T82-571l57-200q4-13 14-21t24-8h606q14 0 24 8t14 21l57 200q5 19-6.5 35T840-520h-88l48 360h-80l-27-200H267l-27 200h-80Z"
        fill={color ?? Theme.color.black.DEFAULT}
      />
    </svg>
  );
}
